//see https://fluentuipr.z22.web.core.windows.net/heads/master/theming-designer/index.html
export const palette = {
  themePrimary: '#a02829',
  themeLighterAlt: '#fbf4f4',
  themeLighter: '#f0d3d3',
  themeLight: '#e3b0b0',
  themeTertiary: '#c66d6d',
  themeSecondary: '#ac3a3a',
  themeDarkAlt: '#912424',
  themeDark: '#7a1f1f',
  themeDarker: '#5a1616',
  neutralLighterAlt: '#faf9f8',
  neutralLighter: '#f3f2f1',
  neutralLight: '#edebe9',
  neutralQuaternaryAlt: '#e1dfdd',
  neutralQuaternary: '#d0d0d0',
  neutralTertiaryAlt: '#c8c6c4',
  neutralTertiary: '#a19f9d',
  neutralSecondary: '#605e5c',
  neutralSecondaryAlt: '#8a8886',
  neutralPrimaryAlt: '#3b3a39',
  neutralPrimary: '#323130',
  neutralDark: '#201f1e',
  black: '#000000',
  white: '#ffffff',
};

export const BwjPalette = {
  accentPrimary: '#31566b',
  themePrimaryDark: '#051827',
  themeGrey: '#5A5A5A',
  themeError: '#A72608',
  themeErrorBackground: '#F5E6E3',
  themeWarning: '#E8871E',
  themeWarningBackground: '#FCF1E5',
  themeWarningBackgroundDark: '#EDB458',
  themeInfo: '#0496FF',
  themeInfoBackground: '#E2F3FF',
  themeSuccess: '#248232',
  themeSuccessBackground: '#E3F3E6',
};

  export const fontFamily = "'Montserrat', 'Helvetica Neue', Helvetica, Arial, -apple-system, BlinkMacSystemFont, 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans','Droid Sans', sans-serif";

  // See https://developer.microsoft.com/en-us/fluentui#/styles/web/typography
  // also https://developer.microsoft.com/en-us/fluentui#/controls/web/text
  // below is the size proportional equivalent of the default system, where medium == 1 rem
export const fonts = {
  tiny: {
    fontSize: '0.71rem',
    lineHeight: '1rem',
  },
  xSmall: {
    fontSize: '0.79rem',
    lineHeight: '1.07rem',
  },
  small: {
    fontSize: '0.86rem',
    lineHeight: '1.14rem',
  },
  smallPlus: {
    fontSize: '0.93rem',
    lineHeight: '1.29rem',
  },
  medium: {
    fontSize: '1rem',
    lineHeight: '1.43rem',
  },
  mediumPlus: {
    fontSize: '1.14rem',
    lineHeight: '1.57rem',
  },
  large: {
    fontSize: '1.29rem',
    lineHeight: '1.71rem',
  },
  xLarge: {
    fontSize: '1.43rem',
    fontWeight: 'semibold',
    lineHeight: '2rem',
  },
  xxLarge: {
    fontSize: '2rem',
    fontWeight: 'semibold',
    lineHeight: '2.29rem',
  },
  superLarge: {
    fontSize: '3.43rem',
    fontWeight: 'semibold',
    lineHeight: '3.86rem',
  },
  mega: {
    fontSize: '4.86rem',
    fontWeight: 'semibold',
    lineHeight: '5.43rem',
  },
};